export default __webpack_public_path__ + "1711b41f3ae4cb322eeacae23f124122.ttf";